import { render } from "./brand.vue?vue&type=template&id=2ab40501&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"

import "./brand.vue?vue&type=style&index=0&id=2ab40501&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab40501"]])

export default __exports__